import React from "react";
import Menu from "../Menu/Menu";
import Header from "../Header/Header";
import TryIt from "../TryIt/TryIt";

import Extraction from "../Extraction/Extraction";
import Case from "../Case/Case";
import DemoVideo from "../DemoVideo/DemoVideo";
import Footer from "../Footer/Footer";
// import Contact from "../Contact/Contact";

const Mainlayout = () => {
  return (
    <>
      <Header />
      <Menu />
      <Extraction />
      <Case />
      <DemoVideo />
      <TryIt />
      {/* <Contact /> */}
      <Footer />
    </>
  );
};

export default Mainlayout;
